export const COLOR_INPUT_REGEXP = /^#([0-9a-f]{6}|[0-9a-f]{3})$/i;
